import React, { useState } from "react";
import styles from "./dropdownMonths.module.scss";
import { useParams } from "react-router-dom";

const DropdownMonths = ({ months, selectedMonth, handleMonthClick }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { lang } = useParams();

    const formatMonthLabel = (monthValue) => {
        // monthValue: "MM.YYYY" (e.g. "04.2026")
        if (!monthValue) return lang === "en" ? "Select month" : "Wybierz miesiąc";
        const [m, y] = String(monthValue).split(".");
        const monthNum = parseInt(m, 10);
        const yearNum = parseInt(y, 10);
        if (!Number.isInteger(monthNum) || !Number.isInteger(yearNum)) return monthValue;
        const date = new Date(yearNum, monthNum - 1, 1);
        return date.toLocaleDateString(lang === "en" ? "en-US" : "pl-PL", {
            year: "numeric",
            month: "long",
        });
    };

    return (
        <div className={styles.dropdownWrapper}>
            <button
                className={styles.dropdownToggle}
                onClick={() => setIsOpen(!isOpen)}
            >
                {formatMonthLabel(selectedMonth)}
                <span className={`${styles.arrow} ${isOpen ? styles.open : ""}`} />
            </button>

            {isOpen && (
                <div className={styles.dropdownMenu}>
                    <button
                        onClick={() => {
                            sessionStorage.removeItem("selectedMonth");
                            handleMonthClick(null);
                            setIsOpen(false);
                        }}
                        className={!selectedMonth ? styles.activeMonth : ""}
                    >
                        {lang === "en" ? "All" : "Wszystkie"}
                    </button>
                    {months.map((month, index) => (
                        <button
                            key={index}
                            onClick={() => { handleMonthClick(month); setIsOpen(false); }}
                            className={selectedMonth === month ? styles.activeMonth : ""}
                        >
                            {formatMonthLabel(month)}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DropdownMonths;
